import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from '@/shared/components/ui/sonner';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { router } from './router';

// Version info from build
const version = {
  version: import.meta.env.VITE_VERSION || 'dev',
  gitCommit: import.meta.env.VITE_GIT_COMMIT || 'unknown',
  buildTime: import.meta.env.VITE_BUILD_TIME || 'unknown',
};

function App() {
  useEffect(() => {
    // Log version on app load for debugging
    console.log(
      `%c🚀 Mira Frontend v${version.version}`,
      'color: #3b82f6; font-weight: bold; font-size: 14px'
    );
    console.log(`   Commit: ${version.gitCommit}`);
    console.log(`   Build:  ${version.buildTime}`);
  }, []);

  return (
    <ErrorBoundary>
      <RouterProvider router={router} />
      <Toaster />
    </ErrorBoundary>
  );
}

export default App;
